module.exports = __webpack_public_path__ + "static/img/dGoods.64e64f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dGoods.png
// module id = 285
// module chunks = 0 1 2 3 4 5 6 7 8 9